import type { ModelMessage } from '@/types/msq'

/**
 * Extract plain text from a ModelMessage, supporting string or array content.
 */
export function getMessageText(message: ModelMessage): string {
  if (typeof message.content === 'string') return message.content
  if (Array.isArray(message.content)) {
    return message.content
      .filter((i: any) => i && i.type === 'text' && i.text)
      .map((i: any) => String(i.text))
      .join('\n')
  }
  return ''
}

export function isMessageEmpty(message: ModelMessage): boolean {
  if (message.toolEvents && message.toolEvents.length > 0) return false
  if (typeof message.content === 'string') return message.content.trim().length === 0
  if (Array.isArray(message.content)) {
    const hasImage = message.content.some((item) => item?.type === 'image' && item.image?.base64Data)
    if (hasImage) return false
    const text = message.content
      .filter((item) => item?.type === 'text' && typeof item.text === 'string')
      .map((item) => item.text ?? '')
      .join('')
    return text.trim().length === 0
  }
  return true
}

export function isChatEmpty(messages: ModelMessage[]): boolean {
  if (messages.length === 0) return true
  return messages.every((message) => isMessageEmpty(message))
}
